<template lang="pug">
modal#change-type-signer-modal.text-center(
  :buttonColor='buttonColor'
  :close-button-label='$t("modal.changeTypeSigner.cancelButton")'
  :loading='loading'
  :process-button-label='$t("modal.changeTypeSigner.confirmButton")'
  :title='$t("modal.changeTypeSigner.title")'
  @process='$emit("process"); $refs.modal.close()'
  processButtonClass='btn-danger'
  ref='modal'
  size='sm'
)
  .text-start {{ $t('modal.changeTypeSigner.message') }}
  img.mt-4.mb-3(
    alt='draft-delete-warning'
    src='/img/ilustrations/signature-failure.svg'
  )
</template>

<script>
import Modal from '@/ui/molecules/Modal.vue';
import ImageLoader from '@/ui/molecules/ImageLoader.vue';

export default {
  name: 'DeleteRecipientModal',
  components: {
    Modal,
    ImageLoader,
  },
  data() {
    return {
      loading: false,
      buttonColor: true,
    };
  },
};
</script>
